import React from 'react';
import PropTypes from 'prop-types';

import { Text } from './style';

const Seller = ({ original }) => {
  const { companies = [] } = original;
  const sellerSeller = companies[0] ? companies[0].code : '--';
  return (
    <Text>{sellerSeller}</Text>
  );
};

Seller.propTypes = {
  original: PropTypes.shape({
    companies: PropTypes.arrayOf({}),
  }),
};
Seller.defaultProps = {
  original: {},
};

export default Seller;
